import script from "./ListAndFormUnidadeAndSectors.vue?vue&type=script&setup=true&name=list&lang=js"
export * from "./ListAndFormUnidadeAndSectors.vue?vue&type=script&setup=true&name=list&lang=js"

import "./ListAndFormUnidadeAndSectors.vue?vue&type=style&index=0&id=4b1024f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b1024f6"]])

export default __exports__